export default __webpack_public_path__ + "static/media/GR00027-disciple_medal_3.88ea9b59.svg";